



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIEXPERIENCEGETBYID= createAsyncThunk(
  "AlumniExperienceGetById/AlumniExperienceGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniExperienceGetByIdSlice = createSlice({
  name: "AlumniExperienceGetByIdSlice",
  initialState: {
    AlumniExperienceGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniExperienceGetById: (state) => {
        state.AlumniExperienceGetById.loading = false
        state.AlumniExperienceGetById.error = false
        state.AlumniExperienceGetById.data = []
        state.AlumniExperienceGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIEXPERIENCEGETBYID.fulfilled, (state, action) => {
      state.AlumniExperienceGetById = {
        ...state.AlumniExperienceGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIEXPERIENCEGETBYID.pending, (state, action) => {
      state.AlumniExperienceGetById = {
        ...state.AlumniExperienceGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIEXPERIENCEGETBYID.rejected, (state, action) => {
      state.AlumniExperienceGetById = {
        ...state.AlumniExperienceGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniExperienceGetByIdAction = {
    ALUMNIEXPERIENCEGETBYID,
};

export { AlumniExperienceGetByIdAction };
export default AlumniExperienceGetByIdSlice.reducer;
export const {setInitialStateOfAlumniExperienceGetById} = AlumniExperienceGetByIdSlice.actions
